import { render, staticRenderFns } from "./stock_receipts.vue?vue&type=template&id=5b9d0406"
import script from "./stock_receipts.vue?vue&type=script&lang=js"
export * from "./stock_receipts.vue?vue&type=script&lang=js"
import style0 from "./stock_receipts.vue?vue&type=style&index=0&id=5b9d0406&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports